// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {

	$(document).ready(function () {

		document.querySelector('.mobile-nav__menu').addEventListener('click', function () {
			document.querySelector('.header__nav').classList.add('open');
		});
		document.querySelector('.header__close-nav').addEventListener('click', function () {
			document.querySelector('.header__nav').classList.remove('open');
		})

		let home = document.querySelector('body#home')
		if (home) {
			scrollDownAction(104, 'scroll');
		} else {
			var logoHeader = document.querySelector('.js-scroll-logo img');
			var getLogoUrl;
			var getDataLogo;
			if (logoHeader.length !== 0) {
				getLogoUrl = logoHeader.src || [];
				getDataLogo = logoHeader.getAttribute('data-scroll');
				logoHeader.src = getDataLogo;
			}
		}

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		//Acts when scroll down page.
		// $(window).scroll(function (event) {
		// 	scrollDown();
		// });

		// Main Nav Dropdown
		$("#primary-nav li").hover(function () {
			$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {
			$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});

	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};



}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 104) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEle = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEle.length; i++) {
		var viewportOffset = animatedEle[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if (topPos <= window_height * 0.7) {
			animatedEle[i].classList.add('fade-in');
		}
	}
	const window_height_pattern = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade-3');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if (topPos <= window_height_pattern * 0.6) {
			animatedEl[i].classList.add('fade-in');
		}
	}
}